export default {
  resetPassword: 'Reset password',
  ready: 'The instructions where sent to your email address'
}
